import i18next from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'landingHeader', es);
i18next.addResourceBundle('en', 'landingHeader', en);
i18next.addResourceBundle('pt', 'landingHeader', pt);